<template>
    <div class="d-flex align-items-baseline">
        <check-circle-icon :size="12" class="me-3 flex-shrink-0"/>
        <div>
            {{ (userShortName && amenity.shortName) ? amenity.shortName : amenity.name }}
            <div v-if="(amenity.subItems && amenity.subItems.length) || (amenity.pivot && amenity.pivot.countable && amenity.pivot.countable.length)" class="ps-3">
                <template v-if="amenity.pivot">
                    <div v-for="(countable, cndex) in amenity.pivot.countable" :key="`first-amenities-countable-list-${amenity.id}-${cndex}`">
                        {{ countable.value || '' }} {{ countable.label || '' }}
                    </div>
                    <div v-if="(amenity.id == 72) && amenity.pivot.comments" class="small text-muted">
                        {{ amenity.pivot.comments }}
                    </div>
                </template>
                <template v-if="includeSubAmenities">
                    <amenities-item v-for="(subAmenity, jndex) in amenity.subItems" :key="`first-amenities-sub-list-${amenity.id}-${subAmenity.id}-${jndex}`" :amenity="subAmenity" :userShortName="true" />
                </template>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import CheckCircleIcon from '@/assets/icons/check-circle.svg.vue';
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';


    export default {
        name: 'AmenitiesItem',

        components: {
            CheckCircleIcon,
            ...CommonComponents,
        },

        props: {
            amenity: {
                type: ApiObject,
                required: true,
            },

            includeSubAmenities: {
                type: Boolean,
                default: false,
            },

            userShortName: {
                type: Boolean,
                default: false,
            },
        },
    };

</script>
